import * as React from 'react'
import type * as Dialog from 'primitives/dialog'

import { clientSecrets } from '../lib/client-secrets'

type RootProps = React.ComponentProps<typeof Dialog.Root>

interface AutoOpenClientSecrets {
  paymentIntentClientSecret?: string | null
  setupIntentClientSecret?: string | null
  isFreeTrialAutostartSuccess?: boolean
  isSubscriptionAutostartSuccess?: boolean
}

function hasAutoOpenClientSecrets(clientSecrets: AutoOpenClientSecrets) {
  return Boolean(
    clientSecrets.paymentIntentClientSecret ||
    clientSecrets.setupIntentClientSecret ||
    clientSecrets.isFreeTrialAutostartSuccess ||
    clientSecrets.isSubscriptionAutostartSuccess,
  )
}

export function createPaymentsCompleteScreenDialogHook(clientSecrets: AutoOpenClientSecrets) {
  let isAutoOpenedDialogDismissed = false

  return function usePaymentsCompleteScreenDialog() {
    const isAutoOpenFlow = hasAutoOpenClientSecrets(clientSecrets)
    const [open, setOpen] = React.useState(() => isAutoOpenFlow && !isAutoOpenedDialogDismissed)

    return {
      getRootProps(props?: RootProps) {
        const { open: controlledOpen, onOpenChange, ...rest } = props ?? {}

        return {
          ...rest,
          open: controlledOpen ?? open,
          onOpenChange: (nextOpen: boolean) => {
            onOpenChange?.(nextOpen)

            if (isAutoOpenFlow && !nextOpen) {
              isAutoOpenedDialogDismissed = true
            }

            if (controlledOpen === undefined) {
              if (isAutoOpenFlow && nextOpen && isAutoOpenedDialogDismissed) {
                return
              }

              setOpen(nextOpen)
            }
          },
        }
      },
    }
  }
}

export const usePaymentsCompleteScreenDialog = createPaymentsCompleteScreenDialogHook(clientSecrets)
